export const UPDATE_USER_REQUEST = " UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = " UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = " UPDATE_USER_FAILURE";
